<template>
    <div class="campaign-box">
        <div class="campaign-option--title">Budget</div>
        <div v-if="showChangeBudgetWarning" class="row m-b-lg">
            <div class="col-md-12 m-t-sm text-danger">
                <div class="alert-danger">
                    These budget changes will take effect at 8 AM{{ element.budget_pending ? ' and the pending one will be deleted' : '' }}.
                    <div v-if="showPendingBudgetOverride">
                        <input type="checkbox" value="false" v-model="element.budget_pending_override"> Override pending budget & force new budget to go live now
                    </div>
                </div>
            </div>
        </div>
        <budget-weekly v-model="element.budgets" :dimensions-budget-intervals="dimensions.budget_intervals" :product-category-id="productCategoryId" class="m-t-lg">
            <label slot="budgetAmountError" v-show="showErrors && !validation.budget_amount" class="error" v-cloak>The Budget field is required.</label>
            <label slot="budgetAmountErrorWeekly" v-show="showErrors && !validation.budget_amount" class="error" v-cloak>The Budget field is required.</label>
        </budget-weekly>
        <div v-if="element.budget_pending">
            <div class="row m-b-lg">
                <div class="col-md-12 m-t-sm text-danger">
                    <hr style="border-width: 2px;">
                    <div class="alert-danger">
                        Pending budget changes will take effect at 8 AM.
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 m-b-md">
                    <strong>Budget Type</strong> <br>
                    {{ budgetPending.type | capitalize }}
                </div>
                <div v-if="['WEEKDAY', 'DAILY'].includes(budgetPending.type)" class="col-md-3 m-b-md">
                    <strong>Budget Amount</strong> <br>
                    {{ budgetPendingTotal | currency }}
                </div>
            </div>
            <div v-if="budgetPending.type === 'WEEKDAY'" class="row">
                <div class="col-md-12 m-b-lg">
                    <div v-for="weekDay in weekDays" style="width: 13%;float: left;">
                        <strong>{{ weekDay | capitalize }}</strong><br/>
                        {{ budgetPending.amounts[weekDay] | currency }}
                    </div>
                </div>
            </div>
            <div class="row m-b-lg">
                <div class="col-md-12 m-b-lg">
                    <button @click="deletePendingBudget()" type="button" class="btn btn-danger">Discard Pending Budget</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import get from 'lodash/get';
    import has from 'lodash/has';
    import isEqual from 'lodash/isEqual';
    import BudgetWeekly from './budget-weekly.vue';
    import campaignCommon from '../../../campaigns/common';
    import Swal from "sweetalert2";

    export default {
        mixins: [campaignCommon],

        props: [
            'value',
            'dimensions',
            'validation',
            'productCategoryId',
            'showErrors',
            'creating',
            'userRoles'
        ],

        data() {
            return {
                originalBudget: JSON.parse(JSON.stringify(this.value.budgets)),
                element:        this.value,
                weekDays:       ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
            };
        },

        computed: {
            budgetPending() {
                return get(this.element, 'budget_pending.budget', null);
            },

            budgetPendingTotal() {
                if (!has(this.element, 'budget_pending.budget')) {
                    return 0;
                }

                const budgetPending = this.budgetPending;
                let total = 0;

                if (budgetPending.type === 'WEEKDAY') {
                    total = Object.entries(budgetPending.amounts).reduce((acc, [key, value]) => {
                        acc = acc + (value * 1);
                        return acc;
                    }, 0);
                }

                if (budgetPending.type === 'DAILY') {
                    return budgetPending.amount;
                }

                return total;
            },

            showChangeBudgetWarning() {
                if (this.creating || !this.featureFlag('ad-set-budget-pending-scheduling')) {
                    return false;
                }

                return !isEqual(this.originalBudget, this.element.budgets);
            },

            showPendingBudgetOverride() {
                // pending budget override checkbox is only for BR staff
                return this.userRoles.includes('staff') || this.userRoles.includes('engineer');
            }
        },

        watch: {
            value(val) {
                this.element = val;
            }
        },

        methods: {
            deletePendingBudget() {
                $.loading.show();

                axios.delete('/campaigns/budget-pending/' + this.element.id)
                    .then((response) => {
                        $.loading.hide();
                        if (get(response, 'data.success', false)) {
                            this.element.budget_pending = null;
                            new Swal({ title:  'Success',
                                titleText: 'Budget pending changes discarded',
                                'type':    'success'
                            });
                        }
                    })
                    .catch(() => {
                        $.loading.hide();
                        new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error');
                    });
            }
        },

        components: {
            BudgetWeekly
        }
    };
</script>

<style scoped>
    .campaign-box .alert-danger {
        padding: 6px;
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }
</style>
